import { useEffect, useRef, useState } from "react";
import { Button, Card, Row } from "react-bootstrap";
import { getHappycallQuestionList, getCustomersHappycallGrades } from "../store/api/HappycallAPI";
import DatePicker from "react-datepicker2";
import moment from "moment-jalali";
import { Clipboard2DataFill, FileEarmarkExcelFill, Headphones, PrinterFill } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import Loader from "react-loader-spinner";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";
import { exportToExcel, onDateChange } from "../../store/api/CommonFunctions";
import ModalHappyCall from "../../Components/Modals/ModalHappyCall";
import { useDispatch } from "react-redux";
import { getAllProvinces } from "../../store/api/LocationAPI";


export default function CustomersHappycallGrades() {
    const dispatch = useDispatch();
    const [dataList, setDataList] = useState(null);
    const [pending, setPending] = useState(false);
    const [chartType, setChartType] = useState("Bar");
    const inputCDateFrom = useRef();
    const inputCDateTo = useRef();
    const inputEDateFrom = useRef();
    const inputEDateTo = useRef();
    const inputDateFrom = useRef();
    const inputDateTo = useRef();
    const chartContainer = useRef();
    const [questionList, setQuestionList] = useState([]);
    const [searchData, setSearchData] = useState({});
    const [modalStaff, setModalStaff] = useState({ show: false });
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [modalHappycall, setModalHappyCall] = useState({ show: false });
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نماینده", colName: "AgencyName" },
        { colTitle: "سرویس", colName: "PServiceType+InvoiceNumber", showInMobile: true, colType: "string" },
        { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate" },
        { colTitle: "شروع گارانتی", colName: "PGaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGaranteeEndDate" },
        { colTitle: "محصول", colName: "HolderName+ProductName+ProductModel", colType: "string" },
        { colTitle: "مشتری", colName: "CustomerCode+CustomerName", colType: "string" },
        { colTitle: "شماره تماس مشتری", colName: "CustomerPhone+CustomerMobile", colType: "string" },
        { colTitle: "سطح", colName: "Grade" },
        { colTitle: "تحویل/ارسال", colName: "PSendOrDeliveryDate" },
        { colTitle: "استان", colName: "ProvinceName" },
        { colTitle: "شهر", colName: "CityName" },
        { colTitle: "توضیحات", colName: "Description" }
    ]
    const rowButtons = [
        {
            title: "پرسشنامه",
            type: "common",
            tooltip: "پرسشنامه",
            //className: string;
            onclick: showModalHappyCall,
            icon: <Headphones size={18} color="blue" />
        }

    ]
    const onServiceTypeChange = (serviceType) => {
        searchData.ServiceType = serviceType;
        if (!(serviceType?.length > 0)) {
            getHappycallQuestionList(0, true, true, setQuestionList);
        }
        const activeInInstall = serviceType?.toLowerCase() === "install";
        const activeInRepair = serviceType?.toLowerCase() === "repair";

        getHappycallQuestionList(0, activeInInstall, activeInRepair, setQuestionList);
    }
    const search = () => {
        setDataList("PENDING");
        if (inputCDateFrom.current.input.value === "") {
            searchData.CreationDateFrom = null;
        }
        if (inputCDateTo.current.input.value === "") {
            searchData.CreationDateTo = null;
        }
        if (inputDateFrom.current.input.value === "") {
            searchData.FirstContactDateFrom = null;
        }
        if (inputDateTo.current.input.value === "") {
            searchData.FirstContactDateTo = null;
        }
        if (inputEDateFrom.current.input.value === "") {
            searchData.EventDateFrom = null;
        }
        if (inputEDateTo.current.input.value === "") {
            searchData.EventDateTo = null;
        }
        searchData.QuestionText = questionList.find(q => Number(q.ID) === Number(searchData.QuestionID))?.QuestionText
        searchData.Take = searchData.Take ?? 10;
        searchData.Skip = 0;
        dispatch(getCustomersHappycallGrades(searchData));
    }
    const onPageChange = (data) => {
        dispatch(getCustomersHappycallGrades(data));
    }
    const showService = (row) => {
        if (Number(row.ServiceID) > 0)
            window.open(`/Services/Service/${row.ServiceID}/${row.ServiceType}`);
    }
    const handlePrint = (e) => {
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "CustomersHappycallGrades" });
    }
    function toExcel() {
        const url = "api/HappycallAPI/getCustomersHappycallGrades";
        const searchArgs = { ...searchData };
        setPending(true);
        exportToExcel("CustomersHappycallGrades", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showModalHappyCall(row) {
        if (!(Number(row.ServiceID) > 0)) {
            return;
        }
        setModalHappyCall({
            show: true,
            ProductID: row.ProductID,
            ServiceType: row.ServiceType,
            ServiceID: row.ServiceID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            InvoiceNumber: row.InvoiceNumber,
            PServiceType: row.ServiceType === "repair" ? "تعمیر" : "نصب",
            ProductSerial: row.ProductSerial,
            CustomerName: row.CustomerName,
            CustomerPhone: row.CustomerPhone,
            CustomerMobile: row.CustomerMobile,
            ContactDate: row.FirstContactDate ? moment(row.FirstContactDate).format("jYYYY/jMM/jDD HH:mm") : "",
            SendDeliveryDate: row.SendDeliveryDate ? moment(row.SendDeliveryDate).format("jYYYY/jMM/jDD HH:mm") : ""
        })
    }
    const onDateFilterChange = (date, name) => {
        onDateChange(date, name, searchData);
    }
    useEffect(() => {
        dispatch(getAllProvinces());
        getHappycallQuestionList(0, true, true, setQuestionList);
        document.body.classList = 'notMain';
        document.title = "بی همتا-مشتریان";
    }, []);
    return (
        <div className="container-fluid mt-1" style={{ minHeight: '80vh', textAlign: "right" }}>
            <Card>
                <Card.Header className="headerStyle">سطح رضایت مشتریان</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData}
                        dataUrl="api/HappycallAPI/getCustomersHappycallGrades"
                        method="post"
                        fetchBody={{ ...searchData, Take: 0, Skip: 0 }} />
                    <ModalSelectStaff popData={modalStaff} setPopSelectStaff={setModalStaff} />
                    <ModalHappyCall popData={modalHappycall} setPopData={setModalHappyCall} />
                    <br />
                    <Row className="rowBorder">
                        <div className="col-md-2 form-group">
                            <label>نوع سرویس:</label>
                            <select className="search-input" onChange={e => onServiceTypeChange(e.target.value)}>
                                <option value="">انتخاب کنید</option>
                                <option value="repair">تعمیر</option>
                                <option value="install">نصب</option>
                            </select>
                        </div>
                        <div className="col-md-2 form-group">
                            <label>مقیاس: </label>
                            {questionList === "PENDING" &&
                                <Loader color="#bb1370" type="BallTriangle" width={25} height={25} />
                            }
                            {Array.isArray(questionList) &&
                                <select className='search-input' onChange={e => searchData.QuestionID = e.target.value}>
                                    <option value="">انتخاب کنید</option>
                                    {
                                        questionList.map((item, i) => <option key={i} value={item.ID}>{item.QuestionText}</option>)
                                    }
                                </select>
                            }
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ پذیرش از:</label>
                            <DatePicker ref={inputDateFrom} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.FirstContactDateFrom ? moment(searchData.FirstContactDateFrom) : null}
                                onChange={value => onDateFilterChange(value, "FirstContactDateFrom")} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label htmlFor="">تاریخ پذیرش تا:</label>
                            <DatePicker ref={inputDateTo} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.FirstContactDateTo ? moment(searchData.FirstContactDateTo) : null}
                                onChange={value => onDateFilterChange(value, "FirstContactDateTo")} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ ثبت از:</label>
                            <DatePicker ref={inputCDateFrom} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.CreationDateFrom ? moment(searchData.CreationDateFrom) : null}
                                onChange={value => onDateFilterChange(value, "CreationDateFrom")} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ ثبت تا:</label>
                            <DatePicker ref={inputCDateTo} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.CreationDateTo ? moment(searchData.CreationDateTo) : null}
                                onChange={value => onDateFilterChange(value, "CreationDateTo")} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ انجام از:</label>
                            <DatePicker ref={inputEDateFrom} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.EventDateFrom ? moment(searchData.EventDateFrom) : null}
                                onChange={value => onDateFilterChange(value, "EventDateFrom")} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ انجام تا:</label>
                            <DatePicker ref={inputEDateTo} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.EventDateTo ? moment(searchData.EventDateTo) : null}
                                onChange={value => onDateFilterChange(value, "EventDateTo")} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تعداد در صفحه:</label>
                            <select className="search-input" onChange={e => searchData.Take = e.target.value}>
                                <option value="">تمام ردیفها</option>
                                <option value={10}>10 ردیف</option>
                                <option value={20}>20 ردیف</option>
                                <option value={50}>50 ردیف</option>
                                <option value={100}>100 ردیف</option>
                                <option value={1000}>1000 ردیف</option>
                            </select>
                        </div>
                    </Row>
                    <Button className="group-Btn mt-1 mb-1" onClick={search}><Clipboard2DataFill size={18} />&nbsp;خروجی گزارش</Button>
                    {!pending &&
                        <div style={{ padding: 3, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />&nbsp;
                            <PrinterFill onClick={handlePrint} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable rowButtons={rowButtons} columns={tableCols} filterData={searchData} searchMethod={(data) => onPageChange(data)} reducerName="customerDataReducer" objectName="customersHappycallGrades"
                        maxHeight={500} rowClick={showService} hasPaging style={{ whiteSpace: "nowrap" }} />
                </Card.Body>
            </Card>
        </div>
    )
}